import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd04d108"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex mb-2 pl-2 gap-3" }
const _hoisted_2 = {
  class: "m-3",
  style: {"margin-bottom":"3rem !important"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"font-weight":"bold","text-decoration":"underline","text-align":"center"} }, "通行資料", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  key: 0,
  style: {"display":"flex","flex-wrap":"wrap","gap":"4px","justify-content":"left"}
}
const _hoisted_6 = {
  key: 1,
  style: {"display":"flex","align-items":"center","justify-content":"left","height":"100%"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#999999","margin":"0","text-align":"center"} }, "僅學生有簽到表", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "demo-pagination-block mt-3 d-flex justify-content-end" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("大門")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("car教室")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Sunny教室")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("儲藏室")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("週一")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("週二")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("週三")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("週四")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("週五")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("週六")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("週日")
const _hoisted_21 = { class: "dialog-footer" }

import { ref, onMounted, reactive, computed } from "vue";
import { useI18n } from "vue-i18n";
import API from '@/apis/TPSAPI';
import { M_IUsers } from "@/models/M_IUser";
import {M_IsettingAccessRuleForm} from "@/models/M_IsettingAccessRuleForm";
import {M_IUsersContent_MTI} from "@/models/M_IUserList_MTI";
import { M_ICourseOptions } from "@/models/M_ICourseOptions";
import { ComponentSize, FormInstance, FormRules, ElNotification, NotificationParams, ElMessageBox  } from 'element-plus';
import {formatDate, formatTime} from "@/plugins/dateUtils";
import SearchPaginationRequest from "@/models/M_ISearchPaginationRequest";
import DialogAttendance from "@/components/DialogAttendance.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DoorUserSeetingList',
  props: {
    doorId: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  doorId: number
}


const isShowEditRoleDialog = ref(false);
const isShowAttendanceDialog = ref(false);

const handleCloseDialog = () => {
  isShowAttendanceDialog.value = false;
};

const { t } = useI18n();
const userInfo = ref<M_IUsers[]>([]); // Specify the type of the array
const userInfoMTI = ref<M_IUsersContent_MTI | null>(null); // Specify the type of the array
const courseList = ref<M_ICourseOptions[]>([]);
const size = ref<ComponentSize>('default')
const searchText = ref('')
const selectedRole = ref(3) // 預設選擇學生
const selectedType = ref(0) // 預設選擇全部
const doors = [1,2,3,4];
const days = [1,2,3,4,5,6,7];

// 定义 props




const handleSizeChange = async(val: number) => {
  console.log(`${val} items per page`)
  searchPagination.value.SearchPage = val;
  await getStudentPermissions();
}

const handleCurrentChange = async(val: number) => {
  console.log(`current page: ${val}`)
  searchPagination.value.Page = val;
  await getStudentPermissions();
}

const searchPagination = ref<SearchPaginationRequest>({
  SearchText: "",
  SearchPage: 10,
  Page: 1,
  Role: 3,
  type:0
});

const parseTime = (time: string): Date => {
  const [hours, minutes] = time.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
};

//#region 建立表單ref與Validator
// 編輯門禁設定表單
const updateRoleForm = ref<FormInstance>()
const updateFormData = reactive<M_IsettingAccessRuleForm>({
  Id:0,
  userId: 0,
  datepicker: [], // 修改为 Date 对象数组
  timepicker: [],
  days: [],
  groupIds: [],
  datefrom: '',
  dateto: '',
  timefrom:'',
  timeto: '',
  displayName: ''

})
//#endregion


//#region UI Events
const onFilterInputed = () => {
  console.log("Search Function");
  if(!searchText.value || searchText.value.trim() === ''){
    getStudentPermissions();
  }else{
    setTimeout(()=>{
      console.log(searchText.value)
      searchPagination.value.SearchText = searchText.value
      console.log(searchPagination.value);
      getStudentPermissions();
    }, 500);
  }
}

const onRoleChange = () => {
  console.log("Role Changed:", selectedRole.value);
  searchPagination.value.Role = selectedRole.value;
  getStudentPermissions();
}

const onTypeChange = () => {
  console.log("Type Changed:", selectedType.value);
  searchPagination.value.type = selectedType.value;
  getStudentPermissions();
}

const onEdit = (item: any, userId: number, displayName: string) => {
  isShowEditRoleDialog.value = true;
  console.log(item)
  updateRoleForm.value?.resetFields();

    // 格式化时间
  const timeFrom = parseTime(item.timefrom);
  const timeTo = parseTime(item.timeto);
  
  updateFormData.Id = item.id;
  updateFormData.userId = userId;
  updateFormData.groupIds = item.groupIds;
  updateFormData.datepicker = [item.datefrom, item.dateto];
  updateFormData.timepicker = [timeFrom, timeTo];
  updateFormData.displayName = displayName;
  updateFormData.courseId = item.courseId;
  updateFormData.teacherId = item.teacherId;


  // 檢查 item.days 是否為字符串
  if (typeof item.days === 'string') {
    updateFormData.days = item.days.split(',').map(Number);
  } else if (Array.isArray(item.days)) {
    // 如果 item.days 已經是數組，直接賦值
    updateFormData.days = item.days.map(Number);
  } else {
    // 處理其他可能的類型或情況
    console.warn('item.days 的類型不符合預期:', typeof item.days);
    updateFormData.days = [];
  }
  console.log(updateFormData)
}

const onDelet = async(item: any, userId: number, displayName: string) => {
 
 try {
    await ElMessageBox.confirm("確定刪除?", "提示", {
      confirmButtonText: "確定",
      cancelButtonText: "取消",
      type: "warning",
    });
  } catch (error) {
    return;
  }

 const deleteFormData = reactive<M_IsettingAccessRuleForm>({
    Id:0,
    userId: 0,
    datefrom: '',
    dateto: '',
    timefrom:'',
    timeto: '',
    days: [],
    groupIds: [],
    IsDelete: false
  })

  deleteFormData.Id = item.id;
  deleteFormData.userId = userId;
  deleteFormData.groupIds = item.groupIds;
  deleteFormData.datefrom = item.datefrom;
  deleteFormData.dateto = item.dateto;

  // 格式化时间
  const timeFrom = parseTime(item.timefrom);
  const timeTo = parseTime(item.timeto);

  deleteFormData.timefrom = item.timefrom;
  deleteFormData.timeto = item.timeto;
  deleteFormData.days = item.days;
  deleteFormData.groupIds = item.groupIds;
  deleteFormData.IsDelete = true;

  console.log(deleteFormData)

 try {
    let notifyParam: NotificationParams = {}; 
    const settingResponse = await API.patchStudentPermission(deleteFormData);
    
    // 根據需要處理 settingResponse
    console.log('Permission set successfully', settingResponse);
    console.log('Permission set successfully', settingResponse.data);

    if (settingResponse.data.result != 1) {
        notifyParam = {
          title: "失敗",
          type: "error",
          message: `帳號：${displayName} 刪除失敗`,
          duration: 2000,
        };
      } else {
        notifyParam = {
          title: "成功",
          type: "success",
          message: `帳號：${displayName} 已成功刪除`,
          duration: 2000,
        };
      }

      ElNotification(notifyParam);
      isShowEditRoleDialog.value = false;
      onFilterInputed();

  } catch (error) {
    console.error('Failed to set permission', error);
  }
}

const submitUpdateForm = async () => {
  console.log('Form submitted', updateFormData);

  // 格式化日期为 YYYY-MM-DD
  updateFormData.datefrom = formatDate(new Date(updateFormData.datepicker[0]));
  updateFormData.dateto = formatDate(new Date(updateFormData.datepicker[1]));

  // 格式化时间为 HH:MM
  updateFormData.timefrom = formatTime(new Date(updateFormData.timepicker[0]));
  updateFormData.timeto = formatTime(new Date(updateFormData.timepicker[1]));
  
  console.log('setTime&Date',updateFormData);

  const sentFormData = reactive<M_IsettingAccessRuleForm>({
    Id:0,
    userId: 0,
    datefrom: '',
    dateto: '',
    timefrom:'',
    timeto: '',
    days: [],
    groupIds: [],
    IsDelete: false
  })

  sentFormData.Id = updateFormData.Id;
  sentFormData.userId = updateFormData.userId;
  sentFormData.datefrom = updateFormData.datefrom;
  sentFormData.dateto = updateFormData.dateto;
  sentFormData.timefrom = updateFormData.timefrom;
  sentFormData.timeto = updateFormData.timeto;
  sentFormData.days = updateFormData.days;
  sentFormData.groupIds = updateFormData.groupIds;
  sentFormData.courseId = updateFormData.courseId;
  sentFormData.teacherId = updateFormData.teacherId;

  console.log('change Data From updateFormData to sentFormData',sentFormData);

  
  try {
    let notifyParam: NotificationParams = {};
    const settingResponse = await API.patchStudentPermission(sentFormData);
    
    // 根據需要處理 settingResponse
    console.log('Permission set successfully', settingResponse);
    console.log('Permission set successfully', settingResponse.data);

    if (settingResponse.data.result != 1) {
        notifyParam = {
          title: "失敗",
          type: "error",
          message: `帳號：${updateFormData.displayName} 更新失敗`,
          duration: 2000,
        };
      } else {
        notifyParam = {
          title: "成功",
          type: "success",
          message: `帳號：${updateFormData.displayName} 已成功更新`,
          duration: 2000,
        };
      }

      ElNotification(notifyParam);
      isShowEditRoleDialog.value = false;
      onFilterInputed();

  } catch (error) {
    console.error('Failed to set permission', error);
  }
};

const StudentpermissionId = ref<number | null>(null);

const onView = async (item: any, id: number) => {
  StudentpermissionId.value = id;
  isShowAttendanceDialog.value = true;
}

//#endregion

// 將函式傳到父組件
expose({
  onFilterInputed,
});


//#region Hook functions
onMounted(() => {
  console.log(`Received door ID: ${props.doorId}`);
  getStudentPermissions();
  getCourseOptions();
});

//#endregion

//#region Private Functions
// 多時段API
async function getStudentPermissions() {
  try {
    // const getStudentPermissionsResult = await API.getStudentPermissions();

    /** 取得門禁使用者清單-多時段-後端分頁 */
    const getStudentPermissionsResult = await API.getStudentPermissions(searchPagination.value);
    
    if (getStudentPermissionsResult.data.result != 1) throw new Error(getStudentPermissionsResult.data.msg);
    userInfoMTI.value = getStudentPermissionsResult.data.content;
    console.log("拿userInfoMTI")
    console.log(userInfoMTI.value)

  } catch (error) {
    console.error(error);
  }
}
//#endregion

const dayMap = {
  1: '星期一',
  2: '星期二',
  3: '星期三',
  4: '星期四',
  5: '星期五',
  6: '星期六',
  7: '星期日',
};

const formatDays = (days: number[]) => {
  return days.map(day => dayMap[day]).join(', ');
};

const doorMap = {
  1: '大門',
  2: 'Car教室',
  3: 'Sunny教室',
  4: '儲藏室'
};

const formatDoors = (groupIds: number[]) => {
  return groupIds.map(door => doorMap[door]).join(', ');
};


const formatCourse = (courseId: number): string => {
  const course = courseList.value.find(course => course.courseId === courseId);
  return course ? course.courseName : '未知課程';
};

const teacherMap: { [key: number]: string } = {
  64: '小朝',
  65: 'Car',
  66: '丁喬',
  67: '鄭元',
  68: '學宜',
  69: '周廷',
  70: '思儂',
  71: '琪伶',
  72: '羽安',
  73: '玉璇',
  74: '建軍',
  75: '映伶',
};

const attendanceTypeMap = {
  0: '曠課',
  1: '出席',
  2: '請假'
} as const;

// 定義標籤顏色映射
const attendanceTagTypeMap = {
  0: 'danger',   // 缺席 - 紅色
  1: 'success',  // 出席 - 綠色
  2: 'warning'   // 請假 - 黃色
} as const;

// 獲取出席類型文字
const getAttendanceTypeText = (type: number): string => {
  return attendanceTypeMap[type as keyof typeof attendanceTypeMap] || '未知';
};

// 獲取標籤類型
const getAttendanceTagType = (type: number): string => {
  return attendanceTagTypeMap[type as keyof typeof attendanceTagTypeMap] || 'info';
};

async function getCourseOptions() {
  try {
    const response = await API.getCourse();
    courseList.value = response.data.content;
    console.log(courseList.value);
  } catch (error) {
    console.error('載入課程資料失敗:', error);
  }
}

const Info = ref([]);


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_EditPen = _resolveComponent("EditPen")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        style: {"width":"240px"},
        placeholder: _unref(t)('NameFilter'),
        clearable: "",
        modelValue: searchText.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
        "prefix-icon": _ctx.Filter,
        onInput: onFilterInputed
      }, null, 8, ["placeholder", "modelValue", "prefix-icon"]),
      _createVNode(_component_el_select, {
        modelValue: selectedRole.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedRole).value = $event)),
        placeholder: "選擇角色",
        style: {"width":"120px"},
        onChange: onRoleChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "管理者",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "老師",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "學生",
            value: 3
          }),
          _createVNode(_component_el_option, {
            label: "值班人員",
            value: 4
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: selectedType.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedType).value = $event)),
        placeholder: "選擇門禁種類",
        style: {"width":"120px"},
        onChange: onTypeChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "上課",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "租借教室",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              name: "userInfoMTITable",
              style: {"width":"100%"},
              height: "800",
              data: userInfoMTI.value?.pageItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { type: "expand" }, {
                  default: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _hoisted_4,
                      _createVNode(_component_el_table, {
                        data: props.row.studentPermissions,
                        border: "true",
                        "header-cell-style": { backgroundColor: '#F2F2F2' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            label: _unref(t)('Start Date'),
                            prop: "datefrom",
                            align: "center"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _unref(t)('End Date'),
                            prop: "dateto",
                            align: "center"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _unref(t)('Time'),
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.timefrom) + " ~ " + _toDisplayString(scope.row.timeto), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _unref(t)('Period'),
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(formatDays(scope.row.days)), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _unref(t)('Door Group'),
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(formatDoors(scope.row.groupIds)), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: "課程類別",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(formatCourse(scope.row.courseId)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "老師",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(teacherMap[scope.row.teacherId] || '未知'), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            width: "170px",
                            align: "center",
                            prop: "operate",
                            class: "operateBtnGroup d-flex",
                            label: _unref(t)('operation')
                          }, {
                            default: _withCtx(({ row }: { row: any }) => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                size: "small",
                                onClick: ($event: any) => (onEdit(row, props.row.userId, props.row.displayName))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_EditPen)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(_toDisplayString(_unref(t)('edit')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_button, {
                                type: "danger",
                                size: "small",
                                onClick: ($event: any) => (onDelet(row, props.row.userId, props.row.displayName))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Delete)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_unref(t)('delete')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["label"])
                        ]),
                        _: 2
                      }, 1032, ["data"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: "200",
                  sortable: "",
                  label: _unref(t)('username'),
                  prop: "username"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  width: "200",
                  sortable: "",
                  label: _unref(t)('displayName'),
                  prop: "displayName"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  align: "left",
                  label: "簽到表",
                  "header-align": 'left'
                }, {
                  default: _withCtx((scope) => [
                    (selectedRole.value === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.studentPermissions, (permission) => {
                            return (_openBlock(), _createBlock(_component_el_button, {
                              key: permission.id,
                              type: "warning",
                              size: "small",
                              onClick: ($event: any) => (onView(permission, permission.id))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Document)
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(_toDisplayString(formatCourse(permission.courseId)), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: "120",
                  sortable: "",
                  label: _unref(t)('Number of Settings')
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.studentPermissions.length), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      justify: "end",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_pagination, {
                "current-page": searchPagination.value.Page,
                "onUpdate:current-page": _cache[3] || (_cache[3] = ($event: any) => ((searchPagination.value.Page) = $event)),
                "page-size": searchPagination.value.SearchPage,
                "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((searchPagination.value.SearchPage) = $event)),
                "page-sizes": [10, 50, 100],
                size: size.value,
                layout: "total, sizes, prev, pager, next, jumper",
                total: userInfoMTI.value?.totalItems,
                onSizeChange: handleSizeChange,
                onCurrentChange: handleCurrentChange,
                justify: "end"
              }, null, 8, ["current-page", "page-size", "size", "total"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowEditRoleDialog.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isShowEditRoleDialog).value = $event)),
      title: _unref(t)('edit')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_21, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (isShowEditRoleDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitUpdateForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "updateRoleForm",
          ref: updateRoleForm,
          rules: _ctx.rules,
          model: updateFormData,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "門禁權限",
              prop: "groupIds"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: updateFormData.groupIds,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((updateFormData.groupIds) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(doors, (item) => {
                      return _createVNode(_component_el_checkbox, {
                        key: item,
                        label: item,
                        value: item
                      }, {
                        default: _withCtx(() => [
                          (item === 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_10
                              ], 64))
                            : (item === 2)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_11
                                ], 64))
                              : (item === 3)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _hoisted_12
                                  ], 64))
                                : (item === 4)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _hoisted_13
                                    ], 64))
                                  : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "通行日期",
              prop: "datepicker"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "開始日期",
                  "end-placeholder": "結束日期",
                  modelValue: updateFormData.datepicker,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((updateFormData.datepicker) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "通行時間",
              prop: "timepicker"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  "is-range": "",
                  "range-separator": "至",
                  "start-placeholder": "開始時間",
                  "end-placeholder": "結束時間",
                  modelValue: updateFormData.timepicker,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((updateFormData.timepicker) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "週期",
              prop: "days"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: updateFormData.days,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((updateFormData.days) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(days, (item) => {
                      return _createVNode(_component_el_checkbox, {
                        key: item,
                        label: item,
                        value: item
                      }, {
                        default: _withCtx(() => [
                          (item === 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_14
                              ], 64))
                            : (item === 2)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_15
                                ], 64))
                              : (item === 3)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _hoisted_16
                                  ], 64))
                                : (item === 4)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _hoisted_17
                                    ], 64))
                                  : (item === 5)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _hoisted_18
                                      ], 64))
                                    : (item === 6)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                          _hoisted_19
                                        ], 64))
                                      : (item === 7)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                            _hoisted_20
                                          ], 64))
                                        : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    (_openBlock(), _createBlock(DialogAttendance, {
      key: StudentpermissionId.value,
      visible: isShowAttendanceDialog.value,
      "studentpermission-id": StudentpermissionId.value,
      onClose: handleCloseDialog
    }, null, 8, ["visible", "studentpermission-id"]))
  ], 64))
}
}

})